module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-upload-dragger",
    class: {
      'is-dragover': _vm.dragover
    },
    on: {
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.onDragover($event)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragover = false
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e702c88e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/src/upload-dragger.vue
// module id = 682
// module chunks = 0